import React from "react";
import { useFormContext } from "react-hook-form";
import { useQuery } from "react-query";
import { FormInput } from "common/components/form/hookForms/FormInput";
import { View } from "react-native";
import { FormCheckboxInput } from "common/components/form/hookForms/FormCheckboxInput";
import { useTranslation } from "react-i18next";
import { FormInputSuggestion } from "../../../components/form/FormInputSuggestion";
import { getRenovation } from "../../../api/geocode.api";

interface ConstructionYearFieldProps {
  gap?: number;
  buildYearLabel: string;
}

export const ConstructionYearField: React.FC<ConstructionYearFieldProps> = ({
  gap,
  buildYearLabel,
}) => {
  const { t } = useTranslation();
  const { watch, setValue } = useFormContext();

  const lat = watch("lat");
  const lng = watch("lng");
  const yearRenovation = watch("renovationYear");

  const { isLoading, data } = useQuery(
    ["year_reconstruction_apva", lat, lng],
    () => getRenovation(lat, lng),
    {
      enabled: !!lat && !!lng,
      staleTime: Infinity,
    }
  );

  return (
    <>
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <View
          style={{
            flex: 1,
          }}
        >
          <FormInput
            name="year"
            label={buildYearLabel}
            isRequired
            variant="number"
          />
        </View>
        <View
          style={{
            flex: 1,
            marginLeft: 20,
            marginTop: 15,
          }}
        >
          <FormCheckboxInput
            label={t("propertyForm.buildingRenovated")}
            name="isRenovated"
          />
        </View>
      </View>
      {!!watch("isRenovated") && (
        <View style={{ marginTop: gap }}>
          <FormInput
            name="renovationYear"
            label={t("propertyForm.renovationYear")}
            isRequired
            variant="number"
            disabled={isLoading}
          />
        </View>
      )}
      <FormInputSuggestion
        suggestionLabel={
          String(data?.end_year ?? "") +
          " " +
          t("propertyForm.renovationYear").toLowerCase()
        }
        suggestedValue={data?.end_year}
        currentValue={yearRenovation}
        onAgree={(yearReconstruction) => {
          setValue("isRenovated", true);
          setValue("renovationYear", yearReconstruction);
        }}
        gap={gap}
        address={data?.address_full ?? ""}
        source="APVA"
      />
    </>
  );
};
